import { render, staticRenderFns } from "./DoughnutTest.vue?vue&type=template&id=dd3999c2&"
import script from "./DoughnutTest.vue?vue&type=script&lang=js&"
export * from "./DoughnutTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports